exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirmation-details[data-v-5031fb48] {\n  margin-top: 20px;\n  padding: 15px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n", ""]);

// exports
